import { BaseResource } from 'utils/ApiUtils';

export default class WeatherImpact extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Occurrence Date",
      field: "occurenceDate",
      type: "date",
      defaultSort: "desc"
    },
    {
      title: "Level of Effect",
      field: "Description_Loe"
    },
    {
      title: "Comments",
      field: "comments"
    }
  ];

  static attributes = WeatherImpact.columns.map((r) => r.field);

  static expand = [
    {
      Loe: {
        select: ["Description"]
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, WeatherImpact.attributes);
  }
}
